import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, LocationStatusDTO } from '../../../../../services/api/api';
import { ErrorService } from '../../../../../services/error.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../../../../../services/util.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sb-comp-location-reporting-header',
  templateUrl: './location-header.component.html',
  styleUrls: ['./location-header.component.scss'],
  standalone: false,
})
export class LocationHeaderComponent implements OnInit {
  locationData: LocationStatusDTO;

  constructor(
    private api: API,
    public errorHandler: ErrorService,
    public translate: TranslateService,
    public util: UtilService,
    private destroyRef: DestroyRef
  ) {
    this.locationData = null;
  }

  ngOnInit(): void {
    this.api
      .ss_nm_Network_locationStatus()
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: data => {
          this.locationData = data;
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }
}
